import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React from "react";
import dayjs from "dayjs";
import { DateTimePicker, type DateTimeValidationError } from "@mui/x-date-pickers";

interface IEnhancedDateTimePickerProps {
  id?: string;
  name?: string;
  value: dayjs.Dayjs | null;
  onChange: (value: dayjs.Dayjs | null) => void;
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  error?: boolean;
  placeholder?: string;
  disabled?: boolean;
  onBlur?: React.FocusEventHandler<HTMLDivElement | HTMLInputElement | HTMLTextAreaElement>;
  autoFocus?: boolean;
  required?: boolean;
  maxDate?: dayjs.Dayjs;
  minDate?: dayjs.Dayjs;
  onError?: (error: DateTimeValidationError, value: dayjs.Dayjs | null) => void;
  clearable?: boolean;
  onClear?: () => void;
}

export const EnhancedDateTimePicker: React.FC<IEnhancedDateTimePickerProps> = (props) => {
  const {
    id,
    name,
    value,
    onChange,
    label,
    helperText,
    error,
    disabled,
    onBlur,
    autoFocus,
    required,
    maxDate,
    minDate,
    onError,
    clearable,
    onClear,
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        autoFocus={autoFocus}
        disabled={disabled}
        value={value}
        onChange={onChange}
        maxDate={maxDate}
        minDate={minDate}
        label={label}
        slotProps={{
          popper: {
            style: { zIndex: 10000 },
            placement: "bottom-end",
            modifiers: [
              {
                name: "preventOverflow",
                options: { boundary: "viewport", altAxis: true },
              },
              {
                name: "flip",
                options: { fallbackPlacements: ["top-end", "bottom-start", "top-start"] },
              },
            ],
          },
          desktopPaper: {
            variant: "outlined",
          },
          textField: {
            id: id,
            name: name,
            fullWidth: true,
            error: error,
            helperText: error ? helperText : "",
            size: "small",
            required: required,
            onBlur: onBlur,
          },
          openPickerButton: {
            size: "small",
          },
          field: {
            clearable: clearable,
            onClear: () => onClear && onClear(),
          },
        }}
        sx={{
          zIndex: 1500,
          "& .MuiSvgIcon-root": {
            fontSize: "16px",
          },
        }}
        onError={onError}
        timezone="system"
      />
    </LocalizationProvider>
  );
};
